/**
 * Stripe checkout API — calls the stripe-checkout Edge Function.
 * Mirrors aiApi.ts pattern: requireAuth() → raw fetch() → typed response.
 */

import { requireAuth, invokeEdgeFn } from './supabaseClient.ts';

export async function createCheckoutSession(packId: string): Promise<string> {
  await requireAuth();
  const data = await invokeEdgeFn('stripe-checkout', { action: 'create-checkout', pack_id: packId }, { retry: false });
  return data.checkout_url;
}

export interface PurchaseRecord {
  id: string;
  pack_id: string;
  tokens_purchased: number;
  amount_cents: number;
  currency: string;
  status: string;
  created_at: string;
  completed_at: string | null;
}

export async function getPurchaseHistory(): Promise<PurchaseRecord[]> {
  await requireAuth();
  const data = await invokeEdgeFn('stripe-checkout', { action: 'purchase-history' }, { retry: false });
  return data.purchases ?? [];
}
